export const calculateBepProximityPercent = (
  operatingRate: number | null | undefined,
  rorMin: number | null | undefined,
  rorMax: number | null | undefined,
  rorBep: number | null | undefined
): number => {
  if (
    !Number.isFinite(operatingRate) ||
    !Number.isFinite(rorMin) ||
    !Number.isFinite(rorMax) ||
    !Number.isFinite(rorBep) ||
    (rorMax as number) <= (rorMin as number)
  ) {
    return 0;
  }
  const halfRange = ((rorMax as number) - (rorMin as number)) / 2;
  if (halfRange <= 0) {
    return 0;
  }
  return Math.max(
    0,
    Math.min(
      100,
      (1 - Math.abs((operatingRate as number) - (rorBep as number)) / halfRange) *
        100
    )
  );
};

export const calculateMotorMarginPercent = (
  ratedHp: number | null | undefined,
  loadHp: number | null | undefined
): number => {
  if (!Number.isFinite(ratedHp) || (ratedHp as number) <= 0) {
    return 0;
  }
  return (((ratedHp as number) - (Number(loadHp) || 0)) / (ratedHp as number)) * 100;
};

export const calculateFreeGasFraction = (
  freeGasRate: number | null | undefined,
  liquidRate: number | null | undefined
): number | null => {
  if (!Number.isFinite(freeGasRate) || !Number.isFinite(liquidRate)) {
    return null;
  }
  const denominator = (freeGasRate as number) + (liquidRate as number);
  if (denominator <= 0) {
    return null;
  }
  return (freeGasRate as number) / denominator;
};
